import { useFlexSearch } from "react-use-flexsearch"
import * as React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { bool, object, string } from "prop-types"

export const FlexSearchResults = ({
  input,
  searchIndex,
  searchStore,
  floatingResults,
}) => {
  const results = useFlexSearch(input, searchIndex, searchStore)
  return (
    <SearchResultsList floating={floatingResults}>
      {results.length === 0 ? (
        <NoResults>No results matched “{input}”</NoResults>
      ) : (
        results.map(result => {
          const { url, type, title, description } = result
          return (
            <SearchResult to={url}>
              <em>{type.toUpperCase()}</em>
              <strong>{title}</strong>
              <span>{description}</span>
            </SearchResult>
          )
        })
      )}
    </SearchResultsList>
  )
}

FlexSearchResults.defaultProps = {
  floatingResults: false,
}

FlexSearchResults.propTypes = {
  input: string.isRequired,
  searchIndex: string.isRequired,
  searchStore: object.isRequired,
  floatingResults: bool,
}

const SearchResult = styled(Link)`
  display: block;
  padding: 6px;
  text-decoration: none;
  background-color: white;
  color: inherit;
  font-size: 16px;
  text-align: start;

  strong {
    display: block;
    font-size: 14px;
  }

  em {
    font-style: normal;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.third_color};
  }

  span {
    display: block;
    font-size: 14px;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.fifth_color};

    strong {
      text-decoration: underline;
    }
  }
`

const NoResults = styled.div`
  padding: 12px;
  font-size: 10px;
`

const SearchResultsList = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  right: 0;
  background-color: white;
  color: ${({ theme }) => theme.colors.secondary_color};
  overflow: auto;
  max-height: calc(100vh - 72px);
  border-radius: 3px;

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    max-height: 450px;
  }
`
